import { render, staticRenderFns } from "./Horarios.vue?vue&type=template&id=64a2c79a&"
import script from "./Horarios.vue?vue&type=script&lang=js&"
export * from "./Horarios.vue?vue&type=script&lang=js&"
import style0 from "./Horarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports